module.exports = __webpack_public_path__ + "audio/fourAudio.bbbb5ff0.mp3";